module.exports = __webpack_public_path__ + "img/video-pause-button.6e9ab711.svg";